import { createContext, useContext } from 'react';

type MenuContextType = {
  compact: boolean;
};

export const MenuContext = createContext<MenuContextType>({ compact: false });

export const useMenuContext = () => useContext(MenuContext);
